import { client } from '../client';
import { CommentDTO } from '@/types/models';
export const getComments = async (id: string): Promise<CommentDTO[]> => {
  try {
    const result = await client.get(`/plans/${id}/comments`);
    return result.data.data;
  } catch (error) {
    return [];
  }
};
export const commentsOptions = (id: string) => {
  return {
    queryKey: ['pdp-comments', id],
    queryFn: () => getComments(id)
  };
};